var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("編輯資料")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v("請填寫您的資料")]), _c('b-card', {
    attrs: {
      "img-src": _vm.moduleConfig.avatar.doesShow ? _vm.avatarUrl : null,
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_vm.moduleConfig.avatar.doesShow ? _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_vm.moduleConfig.avatar.upload_methods_from_line ? _c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    on: {
      "click": _vm.useLineAvatar
    }
  }, [_vm._v(" 使用LINE頭像 ")]) : _vm._e(), _vm.moduleConfig.avatar.upload_methods_from_device ? _c('SharedButton', {
    staticClass: "s-btn-outline-primary ml-2",
    on: {
      "click": _vm.openFileInput
    }
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _c('span', [_vm._v("上傳照片")])]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "mt-2"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "row mt-2"
  }, _vm._l(_vm.fields, function (field, index) {
    return _c('div', {
      key: "field.".concat(index),
      class: field.class
    }, [field.type === 'text' && field.matched_key ? [_c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "field__label"
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.staff[field.matched_key],
        expression: "staff[field.matched_key]"
      }],
      staticClass: "field__input",
      attrs: {
        "type": "text",
        "autocomplete": "off",
        "placeholder": field.title,
        "disabled": !field.can_edit
      },
      domProps: {
        "value": _vm.staff[field.matched_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.staff, field.matched_key, $event.target.value);
        }
      }
    })])] : _vm._e()], 2);
  }), 0)])], 1), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "size": "lg",
      "variant": "outline-dark",
      "disabled": _vm.buttonLoading,
      "block": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 取消 ")]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "size": "lg",
      "variant": "primary",
      "disabled": _vm.buttonLoading,
      "block": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 送出 ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }